import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const Students = lazyPage(() => import('@/pages/students/Students'));
const StudentProfile = lazyPage(() => import('@/pages/students/StudentProfile'));
const Staff = lazyPage(() => import('@/pages/staff/Staff'));
const StaffAttendance = lazyPage(() => import('@/pages/staff/StaffAttendance'));
const StaffMastersWorkspace = lazyPage(() => import('@/pages/staff/masters/StaffMastersWorkspace'));

export const peopleRoutes: AppRoute[] = [
  {
    path: 'students',
    title: 'Students',
    children: [
      { path: '', title: 'Students', component: Students, yearScoped: true },
      // Moved to Academic Structure; old links land on its tab.
      { path: 'categories', title: 'Student Categories', redirectTo: '/administrator/academics/structure?tab=student-categories' },
      { path: ':studentId/profile', title: 'Student Profile', component: StudentProfile },
    ],
  },
  {
    path: 'staff',
    title: 'Staff',
    children: [
      { path: '', title: 'Staff', component: ModuleMenu },
      { path: 'directory', title: 'Staff Directory', component: Staff },
      { path: 'attendance', title: 'Staff Attendance', component: StaffAttendance },
      { path: 'masters', title: 'Staff Masters', component: StaffMastersWorkspace },
    ],
  },
];
